// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#dialog .el-dialog__body{padding:.5rem 1rem}#dialog .el-dialog__body .dialog-hint{line-height:1rem;display:flex;align-items:center}#dialog .el-dialog__body .dialog-hint .tanhao-icon{color:#e59f42;margin-right:.6rem;font-size:1rem}", ""]);
// Exports
module.exports = exports;
